import Vue from 'vue';

let handler = new Vue({
  methods: {
    handleAsyncError (promise,) {
      return promise.
        then((data,) => ([data, undefined,]),).
        catch((error,) => Promise.resolve([undefined, error,],),);
    },
  },
},);

export default {
  install: function (Vue,) {
    Vue.prototype.$handler = handler;
  },
};
